var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconEditAlt = function SvgIconEditAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20.3"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-edit-alt_svg__cls-1",
    d: "m19.29.18.08.08.31.32a1.1 1.1 0 0 1 0 1.53l-.08.1-.82.86L17 1.23l.82-.83a1.14 1.14 0 0 1 1.47-.22Zm-3 1.76 1.86 1.83L10 11.93l-2.21.88a.43.43 0 0 1-.56-.48v-.07l.91-2.16Zm-2.92-.1-2.09 2.05H3.05a1 1 0 0 0-1 .89v12.47a1 1 0 0 0 .88 1H15.4a1 1 0 0 0 1-.89V9l2.05-2v9.48a4.36 4.36 0 0 1-.4 2.31 2.68 2.68 0 0 1-1.13 1.13 4.26 4.26 0 0 1-2.31.41H3.85a4.28 4.28 0 0 1-2.32-.41A2.73 2.73 0 0 1 .4 18.76a4.36 4.36 0 0 1-.4-2.31V5.69a4.36 4.36 0 0 1 .4-2.31 2.82 2.82 0 0 1 1.13-1.14 4.4 4.4 0 0 1 2.32-.4Z"
  })));
};

export default SvgIconEditAlt;